import { HttpService } from '@/services/common/HttpService'

const httpService = new HttpService()

export default {
  simulateTrip (payload) {
    const url = `/synthetic-data/simulateTrip`
    return httpService.post(url, payload)
  },
}
